import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const tableHeadVariants = tv({
  base: "border-b border-line px-4 py-3 align-top text-xs font-semibold tracking-wider text-content-muted uppercase",
});

export const TableHead = ({ className, ...props }: ComponentProps<"th">) => {
  return <th className={tableHeadVariants({ className })} scope="col" {...props} />;
};
